import { useState, useEffect } from 'react';

export default function useForm(callback, validate) {

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  // eslint-disable-next-line
  }, [errors, isSubmitting]);

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(values));
    setIsSubmitting(true);
  };

  const handleChange = (event) => {
    setIsSubmitting(false);
    event.persist();
    setValues(values => ({ ...values, [event.target.name]: event.target.value }));
  };

  const resetForm = () => {
    setValues({});
  };

  return {
    handleChange,
    handleSubmit,
    values,
    errors,
    resetForm
  }
};
